import { createAsyncThunk } from '@reduxjs/toolkit';

import { getApiErrorMessage } from '../lib/getApiErrorMessage';
import {
    CustomListItem,
    UpdateCustomListItemRequest,
} from '../types/CustomListSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const updateCustomListItem = createAsyncThunk<
    CustomListItem,
    UpdateCustomListItemRequest,
    ThunkConfig<string>
>(
    'customList/updateCustomListItem',
    async ({ listId, itemId, targetQuantity }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;

        try {
            const response = await extra.api.patch<CustomListItem>(
                `/v1/custom-lists/${listId}/items/${itemId}`,
                { targetQuantity },
            );

            return response.data;
        } catch (e) {
            return rejectWithValue(String(getApiErrorMessage(e)));
        }
    },
);
